module.exports = __webpack_public_path__ + "static/media/header-logo.1e588386.svg";